import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 *@see https://jira.vk.team/browse/CLOUDWEB-20159
 */
export const ATTACHES_FIX_URL_NEW_LOGIC = getFeature('attaches-fix-url-new-logic') || false;
